export class BlacklistDetails {

    id: string;
    company: string;
    name: string;
    firstname: string;
    numberPlate: string;
    note: string;
    deleted = false;

    constructor(blacklist?: BlacklistDetails) {
        if (blacklist != null) {
            this.id = blacklist.id;
            this.company = blacklist.company;
            this.name = blacklist.name;
            this.firstname = blacklist.firstname;
            this.numberPlate = blacklist.numberPlate;
            this.note = blacklist.note;
            this.deleted = blacklist.deleted;
        }
    }
}

export class EditorBlacklistDetails extends BlacklistDetails {

    valid: boolean;
    selected: boolean;
    dirty: boolean;

    constructor(blacklist?: BlacklistDetails) {
        super(blacklist);
    }
}

